import { useState } from 'react'

import { track, trackingEvents } from 'modules/core/lib/Tracking'

export interface ModalsState {
  isAddMemberOpen: boolean
  onOpenAddMember: () => void
  onCloseAddMember: () => void
  isEditOpen: boolean
  onOpenEdit: () => void
  onCloseEdit: () => void
  isRemoveOpen: boolean
  onOpenRemove: () => void
  onCloseRemove: () => void
}

const useModals = (teamId?: string): ModalsState => {
  const [isAddMemberOpen, setAdd] = useState(false)
  const [isEditOpen, setEdit] = useState(false)
  const [isRemoveOpen, setRemove] = useState(false)

  const onOpenAddMember = () => {
    track(trackingEvents.teams.addTeamDetailsMembersStart, {
      team_id: teamId,
    })
    setAdd(true)
  }
  const onCloseAddMember = () => {
    setAdd(false)
  }

  const onOpenEdit = () => {
    track(trackingEvents.teams.goToEditTeamInformation, {
      team_id: teamId,
    })
    setEdit(true)
  }

  const onCloseEdit = () => {
    setEdit(false)
  }

  const onOpenRemove = () => {
    track(trackingEvents.teams.deleteTeamStart, {
      team_id: teamId,
    })
    setRemove(true)
  }
  const onCloseRemove = () => {
    setRemove(false)
  }
  return {
    isAddMemberOpen,
    onOpenAddMember,
    onCloseAddMember,
    isEditOpen,
    onOpenEdit,
    onCloseEdit,
    isRemoveOpen,
    onOpenRemove,
    onCloseRemove,
  }
}
export default useModals
